export const riskItemRow = {
  className: 'col-xs-6 col-sm-6 col-md-4 col-lg-4',
  style: {
    margin: '0 0 10px 0'
  }
}
export const riskItemLabel = {
  style: {
    cursor: 'pointer',
    display: 'block',
    fontWeight: 'bold',
    fontSize: '10px',
    textTransform: 'uppercase'
  }
}



// WEBPACK FOOTER //
// ./src/style/inlines.js